import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full py-8 md:py-10 px-6 bg-gradient-to-b from-cream to-green-50/50" data-id="element-41">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="max-w-2xl mx-auto" data-id="element-42">
        <div className="bg-green-50 rounded-3xl p-6 md:p-8 border border-green/20 text-center" data-id="element-43">
          <motion.div initial={{
          scale: 0
        }} whileInView={{
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.2,
          type: 'spring'
        }} className="w-14 h-14 bg-green/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-44">
            <ShieldCheckIcon className="w-7 h-7 text-green" data-id="element-45" />
          </motion.div>

          <h2 className="font-heading text-2xl md:text-3xl font-bold text-brown-dark mb-3" data-id="element-46">
            🛡️ Garantía de 7 Días
          </h2>

          <p className="font-body text-lg text-brown-light leading-relaxed" data-id="element-47">
            Si en 7 días no encontrás al menos 5 recetas que te salven la
            semana,
            <span className="font-semibold text-brown-dark" data-id="element-48">
              {' '}
              te devolvemos el dinero. Sin preguntas.
            </span>
          </p>
        </div>
      </motion.div>
    </section>;
}